"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = require("styled-components");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var square = (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-width: 0;\n    border-style: solid;\n    border-radius: 2px;\n"], ["\n    border-width: 0;\n    border-style: solid;\n    border-radius: 2px;\n"])));
var circle = (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-width: 0;\n    border-style: solid;\n    border-radius: 50%;\n"], ["\n    border-width: 0;\n    border-style: solid;\n    border-radius: 50%;\n"])));
var shapes = {
  square: square,
  circle: circle
};
var _default = shapes;
exports.default = _default;
var templateObject_1, templateObject_2;